import {
  Box, Flex, Text
} from '@huspy/briks-web';
import { ReactNode } from 'react';
import infoWidgetStyles from '@components/v2/InfoWidget/styles';

const { container, titleText, contentText } = infoWidgetStyles;

type Props = {
  title?: string;
  content?: ReactNode | string | number | null;
  isLoading?: boolean;
};

export const InfoWidget = ({
  title,
  content,
  isLoading,
}: Props) => (
  <Box className={ container }>
    <Flex gap='2'>
      <Text className={ titleText }>
        {title}
      </Text>
      <Text className={ contentText }>
        {isLoading ? '?' : content}
      </Text>
    </Flex>
  </Box>
);
